export const getColumnPickerVisibility = state =>
  state.workListColumns.visibility;

export const getWorkListColumnState = state =>
  state.workListColumns.columnState;

export const getWorkListColumnIDsByOrder = state =>
  state.workListColumns.columnOrder;
